import { AppBar, Toolbar, Typography } from "@mui/material";
import AvatarMenu from "./AvatarMenu";
import HeaderMenu from "./HeaderMenu";
import LanguageSwitch from "./LanguageSwitch";
import { BigLogoIcon } from "./svgIcons";
import { useTranslation } from "react-i18next";
import HelpIcon from "components/SVGs/Help";
import { selectShowHelp, toggleShowHelp } from "features/ui";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { useContext } from "react";
import { FireBaseContext } from "contexts/FireBase";

const customStyles = {
  appBar: {
    height: "70px",
    position: "static",
    backgroundColor: "rgb(255 255 255)",
    transition: "all 150ms ease 0s",
    boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    "@media print": {
      display: "none",
    },
  },
  container: {
    display: "flex",
  },
  headerLogo: {
    fontSize: "5rem",
    width: "unset",
    padding: "1rem 0",
  },
  help: {
    width: "38px",
    height: "38px",
    borderRadius: "50%",
    padding: "3px",
    backgroundColor: "rgb(232 235 241)",
    color: "rgb(169, 175, 187)",
    cursor: "pointer",
    "&:hover": {
      borderRadius: "50%",
      border: "1px solid rgb(98 195 238)",
      color: "rgb(98 195 238)",
      background: "rgb(255 255 255)",
    },
  },
  activeHelp: {
    borderRadius: "50%",
    border: "1px solid rgb(98 195 238)",
    color: "rgb(98 195 238)",
    background: "rgb(255 255 255)",
  },
  actionIcons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    " & > *": {
      margin: "0 0.2rem",
    },
  },
  langSwitch: {
    marginRight: "20px",
    width: "38px",
    height: "38px",
    lineHeight: "38px",
  },
};

const Header = () => {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const currentDirection = i18n.dir();
  const showHelpState = useAppSelector(selectShowHelp);
  const authToken = localStorage.getItem("abjadToken");
  const { logEvent } = useContext(FireBaseContext);

  const helpHandler = () => {
    if (!showHelpState) {
      logEvent("HelpHit");
    }
    dispatch(toggleShowHelp());
  };
  return (
    <AppBar sx={customStyles.appBar} id="appBar">
      <Toolbar sx={customStyles.container}>
        <BigLogoIcon sx={customStyles.headerLogo} />
        {authToken ? <HeaderMenu /> : null}
        <Typography
          component="div"
          sx={{
            ...customStyles.actionIcons,
            ...(currentDirection === "rtl"
              ? { marginRight: "auto" }
              : { marginLeft: "auto" }),
          }}
        >
          {authToken ? (
            <>
              <HelpIcon
                sx={{
                  ...customStyles.help,
                  ...(showHelpState ? customStyles.activeHelp : {}),
                }}
                onClick={helpHandler}
              />
              <AvatarMenu />
            </>
          ) : null}
          <Typography component="span" sx={customStyles.langSwitch}>
            <LanguageSwitch />
          </Typography>
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
